export default __webpack_public_path__ + "static/media/listmaker-demo.9a802260.mp4";